const CHECK_NEW_ORDERS_FAILED = "CHECK_NEW_ORDERS_FAILED";
const CHECK_NEW_ORDERS_FAILED_SUCCESS = "CHECK_NEW_ORDERS_FAILED_SUCCESS";
const CHECK_NEW_ORDERS_FAILED_FAILURE = "CHECK_NEW_ORDERS_FAILED_FAILURE";
const CLEAR_CHECK_NEW_ORDERS_FAILED = "CLEAR_CHECK_NEW_ORDERS_FAILED";
const checkNewOrdersFailedSymbols = {
  CHECK_NEW_ORDERS_FAILED_SUCCESS,
  CHECK_NEW_ORDERS_FAILED_FAILURE,
  CHECK_NEW_ORDERS_FAILED,
  CLEAR_CHECK_NEW_ORDERS_FAILED,
};
export default checkNewOrdersFailedSymbols;
